// extracted by mini-css-extract-plugin
export default {"card":"GenderSelect_card__Aq6aB","circle":"GenderSelect_circle__xnP2k","cardSelected":"GenderSelect_cardSelected__nVmwD","text":"GenderSelect_text__0YI0n"};